import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "../utils/util.js";
import { buildLoginLocation, persistLoginRedirect, normalizeLoginRedirect } from "../utils/loginRedirect.js";
Vue.use(VueRouter);
const routes = [
  { path: "/", name: "Index", component: () => import("../views/Index.vue") },
  {
    path: "/courses",
    name: "Courses",
    component: () => import("../views/Courses.vue"),
  },
  {
    path: "/study",
    name: "Study",
    component: () => import("../views/Study.vue"),
  },
  {
    path: "/courseDetail",
    name: "CourseDetail",
    component: () => import("../views/CourseDetail.vue"),
  },
  {
    path: "/filePreview",
    name: "FilePreview",
    component: () => import("../views/FilePreview.vue"),
  },
  {
    path: "/studentRegister",
    name: "StudentRegister",
    component: () => import("../views/StudentRegister.vue"),
  },
  {
    path: "/teacherRegister",
    name: "TeacherRegister",
    component: () => import("../views/TeacherRegister.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: () => import("../views/Agreement.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/loginMiddle",
    name: "LoginMiddle",
    component: () => import("../views/LoginMiddle.vue"),
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("../views/Test.vue"),
  },
  {
    path: "/certification",
    name: "Certification",
    component: () => import("../views/Certification.vue"),
  },
  {
    path: "/tournament",
    name: "Tournament",
    component: () => import("../views/Tournament.vue"),
  },
  {
    path: "/tournamentClass",
    name: "TournamentClass",
    component: () => import("../views/TournamentClass.vue"),
  },
  {
    path: "/tournamentDetail",
    name: "TournamentDetail",
    component: () => import("../views/TournamentDetail.vue"),
  },
  {
    path: "/desktopOnlyNotice",
    name: "DesktopOnlyNotice",
    component: () => import("../views/DesktopOnlyNotice.vue"),
  },
  {
    path: "/invitationLetter",
    name: "InvitationLetter",
    component: () => import("../views/InvitationLetter.vue"),
  },
  {
    path: "/studytour",
    name: "Studytour",
    component: () => import("../views/Studytour.vue"),
  },
  {
    path: "/studytourDetail",
    name: "StudytourDetail",
    component: () => import("../views/StudytourDetail.vue"),
  },
  {
    path: "/aigc",
    name: "Aigc",
    component: () => import("../views/Aigc.vue"),
  },
  {
    path: "/aigcDetail",
    name: "AigcDetail",
    component: () => import("../views/AigcDetail.vue"),
  },
  {
    path: "/zpDetail",
    name: "ZpDetail",
    component: () => import("../views/zpDetail.vue"),
  },
  {
    path: "/user/userinfo",
    name: "UserInfo",
    component: () => import("../views/user/UserInfo.vue"),
  },
  {
    path: "/chat",
    name: "Chat",
    component: () => import("../views/Chat/Chat.vue"),
  },
  {
    path: "/studytourLetter",
    name: "StudytourLetter",
    component: () => import("../views/StudytourLetter.vue"),
  },
  {
    path: "/communication",
    name: "Communication",
    component: () => import("../views/Communication.vue"),
  },
  {
    path: "/problem",
    name: "Problem",
    component: () => import("../views/Problem.vue"),
  },
  {
    path: "/communicationDetail",
    name: "CommunicationDetail",
    component: () => import("../views/CommunicationDetail.vue"),
  },
  {
    path: "/publishArticle",
    name: "PublishArticle",
    component: () => import("../views/PublishArticle.vue"),
  },
  {
    path: "/user/userHome",
    name: "UserHome",
    component: () => import("../views/user/UserHome.vue"),
  },
  {
    path: "/user/setting",
    name: "Setting",
    component: () => import("../views/user/Setting.vue"),
  },
  {
    path: "/user/studyCenter",
    name: "StudyCenter",
    component: () => import("../views/user/StudyCenter.vue"),
  },
  {
    path: "/user/myCertificate",
    name: "MyCertificate",
    component: () => import("../views/user/MyCertificate.vue"),
  },
  {
    path: "/user/myTournament",
    name: "MyTournament",
    component: () => import("../views/user/MyTournament.vue"),
  },
  {
    path: "/user/myStudyTour",
    name: "MyStudyTour",
    component: () => import("../views/user/MyStudyTour.vue"),
  },
  {
    path: "/user/myOrder",
    name: "MyOrder",
    component: () => import("../views/user/MyOrder.vue"),
  },
  {
    path: "/user/myActivity",
    name: "MyActivity",
    component: () => import("../views/user/MyActivity.vue"),
  },
  {
    path: "/practice",
    name: "Practice",
    component: () => import("../views/Practice.vue"),
  },
  {
    path: "/chat/picMake",
    name: "PicMake",
    component: () => import("../views/Chat/PicMake.vue"),
  },
  {
    path: "/user/buyPoints",
    name: "BuyPoints",
    component: () => import("../views/user/BuyPoints.vue"),
  },
  {
    path: "/user/coupon",
    name: "Coupon",
    component: () => import("../views/user/Coupon.vue"),
  },
  {
    path: "/user/orderDetail",
    name: "OrderDetail",
    component: () => import("../views/user/OrderDetail.vue"),
  },
  {
    path: "/findAccount",
    name: "FindAccount",
    component: () => import("../views/FindAccount.vue"),
  },
  {
    path: "/courseOnline",
    name: "CourseOnline",
    component: () => import("../views/CoursesOnline.vue"),
  },
  {
    path: "/courseOnlineDetail",
    name: "CourseOnlineDetail",
    component: () => import("../views/CourseOnlineDetail.vue"),
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const token = getToken();
  console.log(token);

  // 判断是否进入需要登录的路由
  if (to.path === "/chat" || to.path === "/study" || to.path.includes("/user")) {
    if (!token) {
      // 没有token，提示并跳转到登录页
      persistLoginRedirect(normalizeLoginRedirect(to.fullPath));
      next(buildLoginLocation(to));
      return;
    }
  }

  next();
});
// 核心代码：路由切换后滚动到顶部
router.afterEach((to, from) => {
  // 滚动到页面顶部，{ behavior: 'smooth' } 可选，实现平滑滚动
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // 去掉则是瞬间回到顶部
  });
});
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

export default router;
